/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chot_So_Disabled_LoadingInputs */

const vi_chot_so_disabled_loading = /** @type {(inputs: Chot_So_Disabled_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang chốt sổ…`)
};

/**

* @param {Chot_So_Disabled_LoadingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const chot_so_disabled_loading = /** @type {((inputs?: Chot_So_Disabled_LoadingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chot_So_Disabled_LoadingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_chot_so_disabled_loading(inputs)
});